/*global $:false */

import BaseM from './recordm.model.entity.js';
import DefinitionM from './recordm.model.entity.definition.js';
import UriBuilder from "../helpers/module.uribuilder.js";

import { sprintf } from 'sprintf-js';

import ui from '@cob/ui-genesis/cob.ui.js';

//Model responsible for configuring domain entity data and settings;
var DomainM = function(core, data) {
    /* eslint-disable-next-line prefer-rest-params */
    BaseM.apply(this, arguments);

    this._core = core;
    this.data = data || {id: undefined};

    this._i18nKey = "recordm.domains";
    this._i18nPrefix = "domain";
    this._entityKey = DomainM.entityKey;

    this.created_event_name = DomainM.created_event_name;

    this.loaded_event_name = "recordm:loaded:domain:" + this.data.id;
    this.update_event_name = "recordm:updated:domain:" + this.data.id;
    this.definition_added_event_name = "recordm:definition-added:domain:" + this.data.id;
    this.definition_removed_event_name = "recordm:definition-removed:domain:" + this.data.id;
    this.delete_event_name = "recordm:deleted:domain:" + this.data.id;
};

DomainM.entityKey = 'domains';
DomainM.created_event_name = 'recordm:created:domain';

DomainM.prototype = new BaseM();
DomainM.prototype.constructor = DomainM;

// The getter for a specific definition
DomainM.get = BaseM.buildGetFor(DefinitionM);

// Compares two domains by their names
// Returns:
// * Negative value = domainM's name comes before otherDomainM's name
// * 0 = both have equivalent names
// * Positive value = otherDomainM's name comes before domainM's name
DomainM.compareNames = function (domainM, otherDomainM){
    return domainM.getName().toUpperCase()
        .localeCompare(otherDomainM.getName().toUpperCase());
};

// Get all the domains.
// This is useful only for domain / definition management.
DomainM.loadAll = function(core, callback) {

    $.ajax({
        'url': 'recordm/domains',
        'type': 'get',
        success: function(domains) {
            var domainsIds = [];

            domains.forEach(function(domain) {
                var domainM = new DomainM(core, domain),
                    domainId = domain.id;

                core.addModel(domainM.getEntityKey() + ":" + domainId, domainM);
                domainsIds.push(domainId);
            });

            if (callback) callback(domainsIds);

        },
        error: function(req) {
            window.console.log("DOMAINS:error: " + req.status + " : " + req.statusText + ":" + req.responseText);
        }
    });
};


DomainM.columns = [
    BaseM._buildEntityField("name", {
        label: "Nome",
        columnWidth: 260,
        type: BaseM.fieldDataType.STRING_PHRASE
    })
];

DomainM.get = BaseM.buildGetFor(DomainM);

DomainM.fieldValidationProps = [
    ["name", true, 50, BaseM.fieldDataType.STRING]
].map(function(arr) { return BaseM._buildFieldValidationProps.apply(BaseM, arr);});

DomainM.prototype.getName = function(){
    return this.data.name;
};

// Returns the domain description
// This is usefull in the breadcrumbs
DomainM.prototype.getDescription = function() {
    return this.data.name;
};

// returns true or false depending
// on the domain having definitions associated
DomainM.prototype.hasDefinitions = function() {
    return this.data.definitions.length > 0;
};

// Remove the definition with this id from this domain
// This will emit the `update_event_name` on success
DomainM.prototype.removeDefinitionFromDomain = function(definitionId) {
    var _this = this;

    $.ajax({
        'url': 'recordm/domains/' + _this.data.id + '/definitions/' + definitionId,
        'type': 'delete',
        success: function(data) {
            _this.data = data;

            _this._core.publish(_this.definition_removed_event_name, {id: _this.data.id, definitionId: definitionId});
        },
        error: function(req) {
            try {
                window.console.log("DOMAINS:error: " + req.status + " : " + req.statusText + ":" + req.responseText);

                if (req.status === 404) {
                    ui.notification.showCustom(
                        'error',
                        sprintf(_this._core.translateString("recordm.domains", "domains.msg.error-title"), _this.data.name),
                        _this._core.translateString("recordm.domains", "domains.msg.not-found")
                    );
                } else {
                    ui.notification.showNotificationsFromRequest('error', req);
                }

            } catch (e) {
                window.console.log(e);
            }
        }
    });
};

// Add the definition with this id to this domain
// This will emit the `update_event_name` on success
DomainM.prototype.addDefinitionToDomain = function(definitionId) {
    var _this = this;

    $.ajax({
        'url': 'recordm/domains/' + _this.data.id + '/definitions/' + definitionId,
        'type': 'put',
        success: function(data) {
            _this.data = data;

            _this._core.publish(_this.definition_added_event_name, {id: _this.data.id, definitionId: definitionId});
        },
        error: function(req) {
            try {
                window.console.log("DOMAINS:error: " + req.status + " : " + req.statusText + ":" + req.responseText);

                if (req.status === 404) {
                    ui.notification.showCustom(
                        'error',
                        sprintf(_this._core.translateString("recordm.domains", "domains.msg.error-title"), _this.data.name),
                        _this._core.translateString("recordm.domains", "domains.msg.not-found")
                    );
                } else {
                    ui.notification.showNotificationsFromRequest('error', req);
                }

            } catch (e) {
                window.console.log(e);
            }
        }
    });

};

DomainM.prototype.buildUriForQuery = function(query) {
    return UriBuilder.buildUriForSearchDomain(this.getId(), query);
};

export default DomainM;
